<template>
  <div class="qualification-wrapper">
    <h3 class="qualification-wrapper-title section-title">Qualifications</h3>
    <div class="tabs">
      <div class="tab" :class="{ active: tab == 'edu' }" @click="tab = 'edu'">
        Education
      </div>
      <div class="tab" :class="{ active: tab == 'trai' }" @click="tab = 'trai'">
        Trainings
      </div>
      <div class="tab" :class="{ active: tab == 'cer' }" @click="tab = 'cer'">
        Certification
      </div>
    </div>
    <div class="tab-body">
      <Education :id="id" v-if="tab == 'edu'"></Education>
      <Trainings :id="id" v-if="tab == 'trai'"></Trainings>
      <Certification :id="id" v-if="tab == 'cer'"></Certification>
    </div>
  </div>
</template>
<script>
import Education from "@/components/ConsultantFullProfile/Qualification/Education.vue";
import Trainings from "@/components/ConsultantFullProfile/Qualification/Trainings.vue";
import Certification from "@/components/ConsultantFullProfile/Qualification/Certification.vue";

export default {
  name: "Qualification",
  components: {
    Education,
    Trainings,
    Certification,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      tab: "edu",
    };
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.qualification-wrapper {
  background: #fff;
  padding: 17px 20px;
  border-radius: 5px;
  @media (min-width: 300px) and (max-width: 630px) {
    padding: 0px 0px;
  }
  .qualification-wrapper-title {
    font-size: 18px;
    padding-bottom: 18px;
    padding-top: 10px;
    padding-left: 10px;
  }
  .section-title {
    @media (min-width: 300px) and (max-width: 630px) {
      font-weight: 800;
    }
  }
  .tabs {
    display: grid;
    grid-template-columns: 33.3% 33.3% 33.3%;
    .tab:nth-child(1) {
      border-top-left-radius: 5px;
      @media (min-width: 300px) and (max-width: 630px) {
        border-top-left-radius: 0px;
      }
    }
    .tab:nth-child(3) {
      border-top-right-radius: 5px;
      @media (min-width: 300px) and (max-width: 630px) {
        border-top-left-radius: 0px;
      }
    }
    .tab {
      background: #cccccc;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 500ms ease-in-out;
      color: #fff;
      &.active {
        background: #f7f7f7;
        color: #1ba5a4;
        font-weight: 800;
        transition: 500ms ease-in-out;
      }
      &:hover {
        color: #1ba5a4;
      }
    }
  }
  .tab-body {
    background: #f7f7f7;
  }
}
</style>